import { ProgramBookActions } from 'src/store/constants';
import { SagaPromise } from './auth-actions';
import { Dispatch } from 'redux';
import { ProgramBookFormData } from 'src/screens/General/screens/ProgramBook/components/ProgramBookForm';
import { QueryParams } from '../../types/grid';
import { ProgramBookAnswerFormData } from '../../screens/General/screens/Providers/screens/ProviderDetail/tabs/CaseSession/components/editSession/ProgramBookAnswerForm';
export interface UpdateProgramBookAction {
    type: typeof ProgramBookActions.PROGRAM_BOOK_UPDATE;
    payload: {
        data: Partial<ProgramBookFormData>;
        callbacks: SagaPromise<any>;
    };
}

export function updateProgramBook(
    data: Partial<ProgramBookFormData>,
    callbacks: SagaPromise<any>,
): UpdateProgramBookAction {
    return {
        type: ProgramBookActions.PROGRAM_BOOK_UPDATE,
        payload: {
            data,
            callbacks,
        },
    };
}

export interface PersistProgramBookAction {
    type: typeof ProgramBookActions.PROGRAM_BOOK_PERSIST;
    payload: {
        data: ProgramBookFormData;
        files: any;
        callbacks: SagaPromise<any>;
    };
}

export const asyncPersistProgramBook = (data: any, files: any, dispatch: any) => {
    return new Promise((resolve, reject) => {
        dispatch(persistProgramBook(data, files, { resolve, reject }));
    });
};
export interface DeleteFileProgramBookAction {
    type: typeof ProgramBookActions.DELETE_FILE_PROGRAM_BOOK;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteFileProgramBook(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteFileProgramBookAction {
    return {
        type: ProgramBookActions.DELETE_FILE_PROGRAM_BOOK,
        payload: { id, onSuccess, onError },
    };
}
export function persistProgramBook(
    data: ProgramBookFormData,
    files: any,
    callbacks: SagaPromise<any>,
): PersistProgramBookAction {
    return {
        type: ProgramBookActions.PROGRAM_BOOK_PERSIST,
        payload: {
            data,
            files,
            callbacks,
        },
    };
}

export const asyncPersistProgramBookAnswer = (data: any, dispatch: any) => {
    return new Promise((resolve, reject) => {
        dispatch(persistProgramBookAnswer(data, { resolve, reject }));
    });
};

export function persistProgramBookAnswer(
    data: ProgramBookAnswerFormData,
    callbacks: SagaPromise<any>,
): PersistProgramBookAnswerAction {
    return {
        type: ProgramBookActions.PROGRAM_BOOK_ANSWERS_PERSIST,
        payload: {
            data,
            callbacks,
        },
    };
}

export interface PersistProgramBookAnswerAction {
    type: typeof ProgramBookActions.PROGRAM_BOOK_ANSWERS_PERSIST;
    payload: {
        data: ProgramBookAnswerFormData;
        callbacks: SagaPromise<any>;
    };
}

export const asyncPersistProgramBookAnswerOfTarget = (data: any, target: any, dispatch: any) => {
    return new Promise((resolve, reject) => {
        dispatch(persistProgramBookAnswerOfTarget(data, target,{ resolve, reject }));
    });
};

export function persistProgramBookAnswerOfTarget(
    data: any,
    target: any,
    callbacks: SagaPromise<any>,
): PersistProgramBookAnswerOfTargetAction {
    return {
        type: ProgramBookActions.PROGRAM_BOOK_ANSWER_OF_TARGET_PERSIST,
        payload: {
            data,
            target,
            callbacks,
        },
    };
}

export interface PersistProgramBookAnswerOfTargetAction {
    type: typeof ProgramBookActions.PROGRAM_BOOK_ANSWER_OF_TARGET_PERSIST;
    payload: {
        data: any;
        target: any;
        callbacks: SagaPromise<any>;
    };
}

export interface PersistPBTargetAction {
    type: typeof ProgramBookActions.PROGRAM_BOOK_TARGET_PERSIST;
    payload: {
        data: any;
        callbacks: SagaPromise<any>;
    };
}

export const asyncPersistPBTarget = (data: any, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistPBTarget(data, { resolve, reject }));
    });
};

export function persistPBTarget(data: any, callbacks: SagaPromise<any>): PersistPBTargetAction {
    return {
        type: ProgramBookActions.PROGRAM_BOOK_TARGET_PERSIST,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncCreateFilesProgramBook = (id: number | string, files: any, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(createFilesProgramBook(id, files, { resolve, reject }));
    });
};

export interface CreateFilesProgramBookction {
    type: typeof ProgramBookActions.PROGRAM_BOOK_CREATE_FILES;
    payload: {
        id: number | string;
        files: any;
        callbacks: SagaPromise<any>;
    };
}

export function createFilesProgramBook(
    id: number | string,
    files: any,
    callbacks: SagaPromise<any>,
): CreateFilesProgramBookction {
    return {
        type: ProgramBookActions.PROGRAM_BOOK_CREATE_FILES,
        payload: {
            id,
            files,
            callbacks,
        },
    };
}

export interface GetProgramBooksAction {
    type: typeof ProgramBookActions.PROGRAM_BOOK_FETCH;
    payload: QueryParams;
}

export function getProgramBooks(params: QueryParams): GetProgramBooksAction {
    return {
        type: ProgramBookActions.PROGRAM_BOOK_FETCH,
        payload: params,
    };
}

export interface GetProgramBooksSmallAction {
    type: typeof ProgramBookActions.PROGRAM_BOOK_SMALL_FETCH;
    payload: QueryParams;
}

export function getProgramBooksSmall(params: QueryParams): GetProgramBooksSmallAction {
    return {
        type: ProgramBookActions.PROGRAM_BOOK_SMALL_FETCH,
        payload: params,
    };
}

export interface GetProgramBookAnswersAction {
    type: typeof ProgramBookActions.PROGRAM_BOOK_ANSWERS_FETCH;
    payload: QueryParams;
}

export function getProgramBookAnswers(params: QueryParams): GetProgramBookAnswersAction {
    return {
        type: ProgramBookActions.PROGRAM_BOOK_ANSWERS_FETCH,
        payload: params,
    };
}

export interface GetProgramBookAction {
    type: typeof ProgramBookActions.PROGRAM_BOOK_FETCH_ENTITY;
    payload: {
        id: string | number;
        isHidden: string | number;
    };
}

export function getProgramBookEntity(id: string | number, isHidden: string | number): GetProgramBookAction {
    return {
        type: ProgramBookActions.PROGRAM_BOOK_FETCH_ENTITY,
        payload: { id, isHidden },
    };
}

export interface GetFilesProgramBookAction {
    type: typeof ProgramBookActions.PROGRAM_BOOK_FETCH_FILES;
    payload: {
        id: string | number;
    };
}

export function getFilesProgramBook(id: string | number): GetFilesProgramBookAction {
    return {
        type: ProgramBookActions.PROGRAM_BOOK_FETCH_FILES,
        payload: { id },
    };
}

export type Actions =
    | UpdateProgramBookAction
    | PersistProgramBookAction
    | PersistPBTargetAction
    | GetFilesProgramBookAction
    | CreateFilesProgramBookction
    | GetProgramBookAction
    | GetProgramBooksSmallAction
    | GetProgramBooksAction;
